import { useSelector } from '../../../../store/store';
import { StageJobs } from '../types';
import { useMemo } from 'react';
import {
    selectMatchedJobs,
    selectExamsHistory,
} from '../../../../store/workspace/selectors';

/**
 * Splits what the applicant has going on into the funnel stages the dashboard
 * shows, so the summary cards and the job box always agree on their contents.
 */
export const useJobStages = (): StageJobs => {
    const jobs = useSelector(selectMatchedJobs);
    const history = useSelector(selectExamsHistory);

    return useMemo(() => ({
        RecruitingInterview: jobs.filter(i => i.status === 'recruitingInterview'),
        MultipleChoice: jobs.filter(i => i.status === 'multipleChoiceExam'),
        Coding: jobs.filter(i => i.status === 'codingExam'),
        Interview: history.filter(i => i.status === 'interview'),
        FinalResult: history.filter(i => i.status === 'finalResult'),
    }), [jobs, history]);
};
